module.exports = __webpack_public_path__ + "static/media/pc_icon_e_follow_hover.dc0f5558.svg";